import {RouteFamily, type RouteRule} from '../types/route';

export const ROUTE_RULES: ReadonlyArray<Omit<RouteRule, 'target'>> = [
  {
    family: RouteFamily.LOCAL,
    prefix: '/api/local',
    rewrite: '/api/local',
  },
  {
    family: RouteFamily.PLUTUS,
    prefix: '/api/plutus/v2',
    rewrite: '/api/v2',
    requiresUserAuth: true,
  },
  {
    family: RouteFamily.PLUTUS_CC,
    prefix: '/api/plutus-cc',
    rewrite: '/api/cc',
    requiresClientCredentials: true,
  },
  {
    family: RouteFamily.CORE_CC,
    prefix: '/api/core-cc',
    rewrite: '/api/v1/cc',
    requiresClientCredentials: true,
  },
  {
    family: RouteFamily.APOLLO_CC,
    prefix: '/api/apollo-cc',
    rewrite: '',
    requiresClientCredentials: true,
  },
  {
    family: RouteFamily.CORE_WEB,
    prefix: '/api/core-web',
    rewrite: '/api',
    requiresUserAuth: true,
  },
  {
    family: RouteFamily.CORE,
    prefix: '/api/core',
    rewrite: '/api/v1',
    requiresUserAuth: true,
  },
  {
    family: RouteFamily.PLUTUS,
    prefix: '/api/plutus',
    rewrite: '/api',
    requiresUserAuth: true,
  },
];
